import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";

const OCEAN_IMG =
  "https://images.unsplash.com/photo-1598674654570-039c170d184a?auto=format&fit=crop&w=1800&q=80";

export default function QuoteBand() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      ref={ref}
      data-testid="quote-band-section"
      className="relative h-[62vh] min-h-[420px] overflow-hidden flex items-center"
    >
      <motion.div style={{ y }} className="absolute inset-[-14%] z-0">
        <img
          src={OCEAN_IMG}
          alt="Aerial view of ocean swell off the coast"
          className="h-full w-full object-cover saturate-[0.7]"
        />
        <div className="absolute inset-0 bg-[#02060D]/65" />
      </motion.div>
      <div className="relative z-10 mx-auto max-w-5xl px-6 lg:px-10">
        <Reveal>
          <blockquote>
            <p
              className="font-display italic text-3xl md:text-5xl tracking-tight leading-snug text-slate-50"
              data-testid="quote-band-text"
            >
              “Experience is the shortest route through complexity.”
            </p>
            <footer className="mt-6 text-xs md:text-sm tracking-[0.25em] uppercase text-teal-400 font-medium">
              The principle behind every Coastal engagement
            </footer>
          </blockquote>
        </Reveal>
      </div>
    </section>
  );
}
